import moment from "moment";

const getDates = (startDate, endDate) => {
    const dates = [];

    const currDate = moment(startDate).startOf("day");
    const lastDate = moment(endDate).startOf("day");

    while (currDate.add(1, "days").diff(lastDate) < 0) {
        dates.push(moment(currDate.clone()).format("YYYY-MM-DD"));
    }

    return dates;
};

export default getDates;



// WEBPACK FOOTER //
// ./src/helpers/getDates.js